var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cart-steps container",attrs:{"id":"cart-steps"}},[(
            _vm.current3DFile &&
                typeof _vm.currentCartItem.scale === 'number' &&
                _vm.currentStep === 'configure'
        )?_c('Configure3DModelScaleSlider'):_vm._e(),_c('div',{staticClass:"cart-steps-container"},[_c('div',{staticClass:"cart-step",class:{
                'is-active': ['upload'].includes(_vm.currentStep),
                'is-completed': ['configure', 'cart'].includes(_vm.currentStep),
            }},[_c('div',{staticClass:"cart-step-number"},[_vm._v("1.")]),_c('div',[_vm._v(_vm._s(_vm.$t('checkout.steps.choose3DFile')))])]),_c('div',{staticClass:"cart-step",class:{
                'is-active': ['configure'].includes(_vm.currentStep),
                'is-completed': ['cart'].includes(_vm.currentStep),
            }},[_c('div',{staticClass:"cart-step-number"},[_vm._v("2.")]),_c('div',[_vm._v(_vm._s(_vm.$t('checkout.steps.choosePrintMode')))])]),_c('div',{staticClass:"cart-step",class:{
                'is-active': ['cart'].includes(_vm.currentStep),
            }},[_c('div',{staticClass:"cart-step-number"},[_vm._v("3.")]),_c('div',[_vm._v(_vm._s(_vm.$t('checkout.steps.checkout')))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }